export default {
  title: 'Ads Tier Management',
  menu: 'Ads Tier Management',
  label: {
    adsTierOne: 'Ads Tier : 1',
    adsTierTwo: 'Ads Tier : 2'
  },
  placeholder: {
  },
  message: {
    saveSuccess: 'Save Advertising order settings success.'
  }
}
